import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './infographic-page-landscape.component.scss';
var InfographicPageLandscape = /** @class */ (function (_super) {
    tslib_1.__extends(InfographicPageLandscape, _super);
    function InfographicPageLandscape(element) {
        return _super.call(this, element) || this;
    }
    InfographicPageLandscape.prototype.init = function () { };
    InfographicPageLandscape.prototype.bindEvents = function () { };
    return InfographicPageLandscape;
}(Base));
export { InfographicPageLandscape };



//////////////////
// WEBPACK FOOTER
// ./components/infographic-page-landscape/infographic-page-landscape.component.ts
// module id = 388
// module chunks = 0